module.exports = __webpack_public_path__ + "static/img/nv.96af5a7.png";


//////////////////
// WEBPACK FOOTER
// ./static/nv.png
// module id = i0CE
// module chunks = 1